<template>
	<b-modal
		size="lg"
		ref="global-search-specimens-modal"
		@hidden="$emit('close')"
		:title="`Buscador Global de Ejemplares`"
		no-close-on-backdrop
		scrollable
		hide-footer
	>
		<div class="d-flex justify-content-between">
			<b-form-group label="Placa o alias del Ejemplar" class="w-100">
				<b-input-group>
					<b-form-input
						v-model="search"
						placeholder="Ingrese placa o alias"
						@keyup.enter="getSpecimens"
					></b-form-input>
					<b-input-group-append>
						<b-button variant="outline-primary" @click="getSpecimens">
							<feather-icon icon="SearchIcon" />
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
		</div>
		<div v-if="specimens.length" class="d-flex justify-content-center flex-wrap my-2">
			<b-card class="m-0 p-0">
				<div class="d-flex flex-wrap justify-content-center">
					<div
						v-for="specimen in specimens"
						:key="specimen.id"
						class="d-flex align-items-center m-1 custom-item"
					>
						<SpecimenPlate :specimen="specimen" show_status show_details_icon />
					</div>
				</div>
			</b-card>
		</div>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import GlobalSearchService from "@/views/amg/header-bookmarks/global-search-specimens/services/global-search.service.js"

export default {
	components: { SpecimenPlate },
	data() {
		return {
			specimenPlate: "",
			specimens: [],
			search: "",
		}
	},
	async mounted() {
		this.$refs["global-search-specimens-modal"].toggle()
	},
	methods: {
		async getSpecimens() {
			if (!this.search) {
				this.showToast("warning", "top-right", "Búsqueda", "InfoIcon", "Ingrese una placa o alias para buscar")
				return
			}
			const { data } = await GlobalSearchService.getSpecimens({
				search: this.search,
			})
			this.specimens = data
			if (this.specimens.length === 0) {
				this.showToast(
					"warning",
					"top-right",
					"Búsqueda",
					"InfoIcon",
					"No se encontraron ejemplares con la placa o alias proporcionado"
				)
			}
		},
	},
}
</script>

<style scoped lang="scss">
.custom-card {
	border: 3px solid var(--primary);
	border-radius: 10px;
	padding: 1rem;
}
.custom-item {
	border: 2px solid var(--primary);
	border-radius: 10px;
	padding: 0.5rem;
}
</style>
